<template>
  <div>
    <STable
      ref="tableref"
      :url="url"
      :columns="columns"
      :handles="handles"
      :query="query"
      :toolbar="toolbar"
      :selection="false"
      label-width="100px"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: '/alarm/peripheral/page',
      allStation: [],
      columns: [
        {
          label: '设备类型',
          prop: 'deviceType'
        },
        {
          label: '设备名称',
          prop: 'deviceName'
        },
        {
          label: '设备编号',
          prop: 'deviceNum'
        },
        {
          label: '网关编号',
          prop: 'gateWayNum'
        },
        {
          label: '归属电站',
          prop: 'StationName'
        },
        {
          label: '运营商',
          prop: 'opName'
        },
        {
          label: '设备状态',
          prop: 'deviceStatus'
        }
      ],
      handles: {
        width: 200,
        btns: [
          {
            label: '修改',
            permission: 'pile.peripheralequipmentmanagement.update',
            handle: (resp) => {
              this.$router.push({
                path: 'nearModify',
                query: { id: resp.id }
              })
            }
          },
          {
            label: '删除',
            permission: 'pile.peripheralequipmentmanagement.delete',
            style: 'color:red',
            url: '/alarm/peripheral/delete',
            method: 'post',
            isConfirm: true,
            before: (index, record) => {
              return [record.id]
              // arr.push(record.id)
            },
            handle: () => {
              this.$refs.tableref.queryTable()
            }
          }
        ]
      },
      query: [
        {
          label: '设备类型',
          prop: 'deviceType',
          placeholder: '请选择设备类型',
          type: 'select',
          data: [
            {
              label: '变压器',
              value: '变压器'
            },
            {
              label: '逆变器',
              value: '逆变器'
            },
            {
              label: '储能系统',
              value: '储能系统'
            },
            {
              label: '换电系统',
              value: '换电系统'
            },
            {
              label: '照明系统',
              value: '照明系统'
            },
            {
              label: '视频监控',
              value: '视频监控'
            }
          ]
        },
        {
          label: '设备编号',
          prop: 'deviceNum',
          placeholder: '请输入设备编号'
        },
        {
          label: '归属电站',
          prop: 'stationName',
          placeholder: '请输入归属电站'
        },
        {
          label: '设备状态',
          prop: 'deviceStatus',
          placeholder: '请选择设备状态',
          type: 'select',
          data: [
            {
              label: '离线',
              value: '离线'
            },
            {
              label: '在线',
              value: '在线'
            }
          ]
        }
        //  {
        //   label: '创建时间',
        //   prop: 'createTime',
        //   placeholder: '',
        //   type: 'date3'
        // }
      ],
      toolbar: [
        {
          label: '新增',
          permission: 'pile.peripheralequipmentmanagement.add',
          type: 'primary',
          before: (index, record) => {
            this.$router.push({
              path: 'nearAdd'
            })
          }
        }
      ]
    }
  },
  mounted() {
    this.$store.dispatch('form/handle', {
      url: '/alarm/peripheral/selectStation',
      method: 'get',
      callback: (resp) => {
        resp.forEach(item => {
          this.allStation.push({ label: item.stationName, value: item.stationID })
        })
        this.query.forEach(item => {
          if (item.prop == 'stationId') {
            item.data = this.allStation
          }
        })
      }
    })
  }
}
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/views/systemManagement/nearRobot.vue